import { render, staticRenderFns } from "./FormularioCambiarContrasena.vue?vue&type=template&id=462fa857&"
import script from "./FormularioCambiarContrasena.vue?vue&type=script&lang=js&"
export * from "./FormularioCambiarContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports